/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechPowerButtonIcon16Light } from './TechPowerButtonIcon16Light';
import { TechPowerButtonIcon16Regular } from './TechPowerButtonIcon16Regular';
import { TechPowerButtonIcon16Solid } from './TechPowerButtonIcon16Solid';
import { TechPowerButtonIcon20Light } from './TechPowerButtonIcon20Light';
import { TechPowerButtonIcon20Regular } from './TechPowerButtonIcon20Regular';
import { TechPowerButtonIcon20Solid } from './TechPowerButtonIcon20Solid';
import { TechPowerButtonIcon24Regular } from './TechPowerButtonIcon24Regular';
import { TechPowerButtonIcon24Solid } from './TechPowerButtonIcon24Solid';
import { TechPowerButtonIcon32Regular } from './TechPowerButtonIcon32Regular';
import { TechPowerButtonIcon64Regular } from './TechPowerButtonIcon64Regular';
var sizes = {
    16: {
        light: TechPowerButtonIcon16Light,
        regular: TechPowerButtonIcon16Regular,
        solid: TechPowerButtonIcon16Solid,
    },
    20: {
        light: TechPowerButtonIcon20Light,
        regular: TechPowerButtonIcon20Regular,
        solid: TechPowerButtonIcon20Solid,
    },
    24: {
        regular: TechPowerButtonIcon24Regular,
        solid: TechPowerButtonIcon24Solid,
    },
    32: {
        regular: TechPowerButtonIcon32Regular,
    },
    64: {
        regular: TechPowerButtonIcon64Regular,
    },
};
export var TechPowerButtonIcon = forwardRef('TechPowerButtonIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
